export default class AliveAnimalInfo {
    constructor(aliveAnimalFound, numberOfAliveAnimals, aliveanimalinfopages) {
        this.aliveAnimalFound = aliveAnimalFound;
        this.numberOfAliveAnimals = numberOfAliveAnimals;
        this.aliveanimalinfopages = aliveanimalinfopages;
    }
}